<template>
  <table
    class="texto-menu-activo"
  >
      <tr :style="{ 'height': height }">
        <td valign="middle" v-if="title">
          <center>{{ title }}</center>
        </td>
        <td valign="middle" v-else ></td>
      </tr>
    </table>
</template>

<script>
import {
  mapState
} from 'vuex'
import i18n from '@/plugins/i18n'
import constants from '@/constants'
import utils from '@/services/utils'
export default {
  components: {
  },
  data: () => ({
    title: null
  }),
  computed: {
    ...mapState('app',['isTotemAccessibility', 'totemMenuSelected']),
    marginTop () {
      return constants.totem.meteo.height + 'px'
    },
    sidebarWidth() {
      return constants.totem.sidebar.width + 'px'
    },
    height() {
      return constants.totem.textoMenuActivo.height + 'px'
    },
    locale () {
      return i18n.locale
    }
  },
  watch: {
    totemMenuSelected: {
      handler: function (newValue) {
        this.title = utils.getTranslation(newValue.Name, this.locale)
      },
      deep: true
    },
  },
  methods: {
  }
}
</script>

<style scoped>
  .texto-menu-activo {
    width: var(--sidebar-width);
    height: var(--height);
    color: white;
    font-size: 20px;
  }
</style>
